module.exports = __webpack_public_path__ + "img/ic_profile_wizard_my_documents.e6b9ed90.svg";